function Hoot() {
  if(typeof window !== "undefined" && window.location.protocol === "https:") {
     return "https://admmnsvserver.eduall.site/";
  } 
  return "https://admmnsvserver.eduall.site/"; 
}

export default Hoot; 